<template>
    <div class="product-header">
        <template v-if="hasHotelDetails">
            <div class="product-header__subtitle mb-0" :class="{ 'mb-3': estimatedClassificationVisible }">
                <Classification
                    v-if="hotelDetails.hotelClassification"
                    :hotelClassification="hotelDetails.hotelClassification"
                    estimateBelowStars
                    class="mt-0"
                ></Classification>

                <Link
                    v-if="hotelDetails.hotelPageVisible"
                    :link="hotelLink"
                    type="hotel"
                    class="product-header__hotel-link"
                >
                    <h1 class="product-header__hotel-name text-truncate">
                        {{ hotelDetails.name }}, {{ hotelDetails.city }}
                    </h1>
                </Link>
            </div>
            <span v-if="bannerText" class="product-header__banner" :style="bannerStyle">{{bannerText}}</span>
            <h2 class="product-header__title my-0">{{ title }}</h2>

            <template v-if="subtitle">
                <div class="product-header__subtitle" v-html="subtitle" />
            </template>
        </template>

        <h1 v-else-if="title" class="product-header__title">{{ title }}</h1>
    </div>
</template>

<script>
import Classification from '@/components/Classification';

export default {
    name: 'ProductHeader',
    data() {
        return {};
    },

    components: {
        Classification
    },

    props: {
        title: String,

        subtitle: String,

        bannerText: String,
        bannerBackgroundColor: String,

        hotelDetails: {
            type: Object,
            required: true
        }
    },

    computed: {
        hotelLink() {
            if (!this.hotelDetails) {
                return;
            }

            const { id, webname } = this.hotelDetails;
            return {
                hotelId: id,
                webnames: [webname]
            };
        },

        bannerStyle() {
          if (this.bannerBackgroundColor) {
            return "background-color: " + this.bannerBackgroundColor + ";";
          }
          return "";
        },

        hasHotelDetails() {
            return this.hotelDetails && this.hotelDetails.id; // hotelDetails.id to distinguish value voucher Animod as hotel from real hotels
        },

        estimatedClassificationVisible() {
            const hotelDetails = this.hotelDetails || {};
            return (
                this.$getSafe(hotelDetails, 'hotelClassification.estimatedClassification') &&
                this.$getSafe(hotelDetails, 'hotelClassification.classificationVisible')
            );
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/bootstrap/breakpoints' as breakpoints;
@use '@/styles/theming' as *;

.product-header {

    &__banner {
      color: var(--white);
      background-color: var(--primary);
      font-size: 15px;
      line-height: 1;
      padding: 5px;
      margin-top: 5px;
      display: inline-block;
      text-transform: uppercase;
      text-align: center;
      white-space: normal;
    }

    &__title {
        font-size: 22px;
        line-height: 35px;
        margin: 6px 0;
    }

    &__subtitle {
        font-size: 20px;
        margin-bottom: 3px;
        display: flex;
        align-items: center;

        ::v-deep {
            p {
                margin-bottom: 0;
            }
        }
    }

    &__hotel-link {
        text-decoration: underline;
        color: inherit;
    }

    &__hotel-name {
        font-size: 18px;
        margin-bottom: 0;
    }
}
</style>
